function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.74 66.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.31,1.26c-3.29,1.68-3.93,1.73-5.79.43C9.03-.76,5.36-.12,2.36,3.44-.15,6.42-.3,7.12.28,12.84c.35,3.4,1.3,8.37,2.11,11.04.89,2.94,1.49,9.19,1.53,15.85.06,12.34,1.13,16.39,5.91,22.43,3.04,3.83,6.25,5.2,7.49,3.18.3-.49-.41-3.06-1.58-5.7-1.86-4.22-2.05-5.97-1.51-14.17.34-5.15.92-9.85,1.29-10.44.92-1.5,3.86,4.47,5.78,11.76,2.43,9.2,5.98,18.77,7.09,19.11,2.31.71,3.58-1.69,4.15-7.83.49-5.25.15-7.97-1.73-13.93-2.71-8.59-3.05-18.86-.96-28.91,1.22-5.87,1.19-6.87-.39-10.18C27.08.02,23.28-1.27,18.31,1.26",
    style: {
      fill: "#010101",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.32,3.76c2.5,1.89,5.97,1.88,7.56-.03,1.98-2.39,5.74-1.82,7.7,1.17,1.99,3.04,2.12,8.28.35,13.66-1.18,3.59-1.32,3.67-6.38,3.68-2.84,0-7.48.63-10.3,1.38l-5.13,1.37-1.07-3.63c-.59-1.99-1.36-5.88-1.72-8.63-.58-4.45-.37-5.3,1.9-7.75,2.87-3.09,4.28-3.34,7.09-1.22",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.25,29.83c.78,4.42,1.83,8.82,4.64,19.4,1.02,3.84.17,14.6-1.05,13.31-.42-.44-2.12-5.6-3.79-11.46-3.98-13.98-6.55-19.07-9.45-18.65-2.63.38-3.57,4.36-3.86,16.31-.14,5.82.26,8.87,1.48,11.2,2.47,4.74,2.04,5.15-1.32,1.26-4.37-5.07-5.93-11.64-5.66-23.95l.22-10.49,5.46-1.15c3-.63,7.04-1.05,8.96-.92,3.36.23,3.54.43,4.36,5.14",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg36);
export default __webpack_public_path__ + "static/media/36.6aead640c4b9d677c496774264d1fb37.svg";
export { ForwardRef as ReactComponent };